"use strict";
exports.__esModule = true;
var types_1 = require("../../types");
exports.createInterruptAttachingToTangle = function (_a) {
    var send = _a.send;
    return function (callback) {
        return send({
            command: types_1.IRICommand.INTERRUPT_ATTACHING_TO_TANGLE
        }).asCallback(callback);
    };
};
//# sourceMappingURL=createInterruptAttachingToTangle.js.map